import React, { useContext } from "react"
import classnames from "classnames"
import { X } from "react-feather"
import icon from "src/images/icon.png"
import User from "src/images/button-icon-user.svg"

import {
  shadow,
  isOpen,
  container,
  menuHeader,
  menuBody,
  close,
  icon as s_icon,
  siteTitle
} from "./menuSidebar.module.css"

import { UserContext } from "src/context/UserContext"
import { CartContext } from "src/context/CartContext"
import { Button } from "src/components/core/atoms/button"
import { Link, navigate } from "gatsby"

const MenuSidebar = () => {
  const { signOut, authUser } = useContext( UserContext )
  const { sidebarIsOpen, dispatchSidebar, ACTIONS } = useContext( CartContext )

  const closeMenu = () => { dispatchSidebar( { type: ACTIONS.MENU_IS_OPEN, payload: false } ) }

  return (
    <>
      <div role="none" className={ classnames( shadow, { [ isOpen ]: sidebarIsOpen.menu } ) } onClick={ closeMenu } />
      <div className={ classnames( container, { [ isOpen ]: sidebarIsOpen.menu } ) } >
        <div className={ menuHeader }>
          <Link to="/" onClick={ closeMenu }>
            <img className={ s_icon } src={ icon } alt={ siteTitle } />
          </Link>
          { authUser && (
            <span>
              <img src={ User } alt="user" />
              { authUser.displayName }
            </span>
          ) }
          <div className={ close }>
            <X onClick={ closeMenu } />
          </div>
        </div>
        <div className={ menuBody }>
          <Button variant="link" to="/about-us" onClick={ closeMenu }>
            About Us
          </Button>
          <Button variant="link" to="/services" onClick={ closeMenu }>
            Services
          </Button>
          <Button variant="link" to="/contact-us" onClick={ closeMenu }>
            Contact Us
          </Button>
          <hr />
          { authUser ? (
            <>
              <Button
                variant="link"
                to="/user/dashboard"
                onClick={ closeMenu }
              >
                My Dashboard
            </Button>
              <Button
                variant="solid"
                onClick={ () => {
                  signOut()
                  closeMenu()
                } }
              >
                Sign out
            </Button>
            </>
          ) : (
            <Button
              variant="solid"
              onClick={ () => {
                closeMenu()
                navigate( '/login', { returnTo: "/" } )
              } }
            >
              Log in
            </Button>
          ) }
        </div>
      </div>
    </>
  )
}

export default MenuSidebar
